import { Fragment } from "react";
import { toPersianNumber } from "../../../classes/utils";

import image from "../../../logo.png";

const PrintOrders = (props) => {
    let { orders, contact_info } = props;

    const A4Width = 210,
        a4Height = 297,
        A5Width = 148,
        A5Height = 210;

    return (
        <html>
            <head>
                <title>سفارشات</title>
            </head>
            <body>
                {orders.map((order) => {
                    let fontSize = 1000 / ((order.items.length + 8) * 1.8);
                    fontSize = fontSize > 18 ? 18 : fontSize;
                    fontSize = fontSize < 9 ? 9 : fontSize;
                    const invoice = (
                        <div
                            className="invoice"
                            style={{
                                width: A4Width + "mm",
                                height: a4Height + "mm",
                                position: "relative",
                                transformOrigin: "center",
                                textAlign: "right",
                                padding: "0mm 15mm",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "row",
                                }}
                            >
                                <img
                                    src={image}
                                    style={{
                                        width: "24mm",
                                        height: "20mm",
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "row",
                                    textAlign: "center",
                                    fontSize: fontSize * 1.25 + "px",
                                }}
                            >
                                فروشگاه اینترنتی نیکا
                            </div>

                            <div
                                style={{
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-evenly",
                                    fontSize: fontSize * 1.25 + "px",
                                }}
                            >
                                <div>{`شماره سفارش : ${toPersianNumber(
                                    order.id
                                )}`}</div>
                                <div>{`${order.name}        ${toPersianNumber(
                                    order.costumerMobile || order.mobile
                                )}`}</div>
                            </div>

                            <table
                                style={{
                                    width: "180mm",
                                    lineHeight: 1.25,
                                    borderCollapse: "collapse",
                                    borderTop: "2px solid black",
                                    fontWeight: 900,
                                    direction: "rtl",
                                    fontSize: fontSize * 1.25 + "px",
                                }}
                            >
                                <tbody>
                                    {order.items.map((item, index) => {
                                        return (
                                            <tr
                                                key={index}
                                                style={{
                                                    borderBottom:
                                                        "1px solid rgba(0,0,0,0.3)",
                                                    fontSize: fontSize + "px",
                                                }}
                                            >
                                                <td>{item.name}</td>

                                                <td>{item.color.name}</td>

                                                <td
                                                    style={{
                                                        padding: "3px 5px",
                                                    }}
                                                >
                                                    {toPersianNumber(
                                                        item.amount,
                                                        true
                                                    )}
                                                    {item.unit}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "3px 5px",
                                                    }}
                                                >
                                                    {toPersianNumber(
                                                        order.check[index]
                                                            .price,
                                                        true
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr
                                        style={{
                                            borderBottom: "3px solid black",
                                        }}
                                    >
                                        <td>قیمت کل اجناس</td>
                                        <td></td>

                                        <td
                                            style={{
                                                padding: "5px 30px",
                                            }}
                                        >
                                            {toPersianNumber(
                                                order.totalItemsPrice,
                                                true
                                            )}
                                        </td>
                                    </tr>
                                    <tr
                                        style={{
                                            borderBottom: "3px solid black",
                                        }}
                                    >
                                        <td>هزینه بسته بندی</td>
                                        <td></td>

                                        <td
                                            style={{
                                                padding: "5px 30px",
                                            }}
                                        >
                                            {toPersianNumber(
                                                order.packingPrice,
                                                true
                                            )}
                                        </td>
                                    </tr>
                                    <tr
                                        style={{
                                            borderBottom: "3px solid black",
                                        }}
                                    >
                                        <td>هزینه ارسال</td>
                                        <td></td>

                                        <td
                                            style={{
                                                padding: "5px 30px",
                                            }}
                                        >
                                            {toPersianNumber(
                                                order.shipping_cost,
                                                true
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>قیمت کل </td>
                                        <td></td>

                                        <td
                                            style={{
                                                padding: "5px 30px",
                                                border: "3px solid black",
                                            }}
                                        >
                                            {toPersianNumber(order.total, true)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );

                    const postal_label = (
                        <div
                            className="postalLabel"
                            style={{
                                height: A5Width + "mm",
                                maxHeight: A5Width + "mm",
                                width: A5Height + "mm",
                                position: "relative",
                                borderBottom: "dotted 5px black",
                                textAlign: "right",
                                padding: "10mm 20mm 0mm 20mm",
                            }}
                        >
                            <div
                                style={{
                                    alignItems: "center",
                                    alignContent: "center",
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <img
                                    src={image}
                                    style={{
                                        width: "31mm",
                                        height: "25mm",
                                    }}
                                />
                                فروشگاه اینترنتی نیکا
                                <div style={{ marginRight: "5mm" }}>
                                    {toPersianNumber(contact_info.mobile)}
                                </div>
                            </div>

                            <div>
                                <div>آدرس فرستنده : </div>
                                <div
                                    style={{
                                        textDecoration: "underline",
                                        fontSize: "21px",
                                        padding: "5px 50px",
                                    }}
                                >
                                    {contact_info.address}
                                </div>

                                <div>کدپستی فرستنده :</div>
                                <div
                                    style={{
                                        textDecoration: "underline",
                                        fontSize: "21px",
                                        padding: "5px 50px",
                                    }}
                                >
                                    {toPersianNumber(contact_info.zip)}
                                </div>

                                <div
                                    style={{
                                        marginTop: "10px",
                                    }}
                                >
                                    <div>آدرس گیرنده :</div>
                                    <div
                                        style={{
                                            textDecoration: "underline",
                                            fontSize: "21px",
                                            padding: "5px 50px",
                                            maxWidth: "70%",
                                        }}
                                    >
                                        {`${order.province_name} - ${order.city_name} - ${order.address}`}
                                    </div>
                                </div>

                                <div>
                                    <div>کد پستی گیرنده :</div>
                                    <div
                                        style={{
                                            textDecoration: "underline",
                                            fontSize: "21px",
                                            padding: "5px 50px",
                                        }}
                                    >
                                        {toPersianNumber(order.zip)}
                                    </div>
                                </div>

                                <div>
                                    <div>تلفن گیرنده :</div>
                                    <div
                                        style={{
                                            textDecoration: "underline",
                                            fontSize: "21px",
                                            padding: "5px 50px",
                                        }}
                                    >
                                        {toPersianNumber(
                                            order.costumerMobile || order.mobile
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div>نام گیرنده :</div>
                                    <div
                                        style={{
                                            textDecoration: "underline",
                                            fontSize: "21px",
                                            padding: "5px 50px",
                                        }}
                                    >
                                        {order.name}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );

                    return (
                        <div
                            className="page"
                            style={{
                                // height: "290mm",
                                width: A4Width + "mm",
                                direction: "rtl",
                                position: "relative",
                                backgroundColor: "rgba(0,0,0,.1)",
                            }}
                            key={order.id}
                        >
                            {invoice}
                            {postal_label}
                        </div>
                    );
                })}
            </body>
        </html>
    );
};

export default PrintOrders;
